import React from 'react';

import PropTypes from 'prop-types';

import MultiSelect from './multiSelect';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const FilterByProduct = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    BUSINESS_APP_ORDERS: { filterByProduct, productFilters }
  } = localizedStrings;

  return (
    <div>
      <MultiSelect
        updateFilters={value => {
          setFilters({ ...filters, productInOrderFor: value });
        }}
        label={filterByProduct}
        options={productFilters.map(item => ({
          label: item.text,
          value: item.value
        }))}
        value={filters.productInOrderFor}
      />
    </div>
  );
};

FilterByProduct.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByProduct;
